export default ['ru', 'en', 'cs'];